module.exports = __webpack_public_path__ + "images/store_case_study/licasta-pic1_464a92333f793adb5c095a93f7fc0aa7.png";